import { Component, inject } from '@angular/core';
import { Validators, FormGroup, FormControl, NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { AuthService } from '@app/core/services/auth.service';
import { getErrorMessages } from '@app/shared/utilities/errorMessages.util';

interface LoginForm {
  userName: FormControl<string>;
  password: FormControl<string>;
  remember: FormControl<boolean>;
}

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './login.component.html'
})
export class LoginComponent {
  private _authService = inject(AuthService);

  form: FormGroup<LoginForm>;
  loading = false;
  errors: string[] | null = null;

  constructor(formBuilder: NonNullableFormBuilder) {
    this.form = formBuilder.group({
      userName: formBuilder.control('', [Validators.required]),
      password: formBuilder.control('', [Validators.required]),
      remember: formBuilder.control<boolean>(true)
    });
  }

  login() {
    this.errors = null;
    this.form.markAllAsTouched();

    if (this.form.invalid) return;

    this.loading = true;

    this._authService
      .login(this.form.value.userName!, this.form.value.password!, this.form.value.remember!)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({ error: (error) => (this.errors = getErrorMessages(error)) });
  }
}
